import { Box } from "@mui/material";
import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { ResponsiveLine } from "@nivo/line";
import { useState } from "react";
import { useEffect } from "react";

export default function ChartIn({ data }) {
  const [convertData, setConvertData] = useState([]);

  let last = [];

  useEffect(() => {
    if (data && data.length > 0) {
      const dataArray = data.map((item) => ({
        id: item.terminalCode,
        color: "#3c6e71",
        fill: "#3c6e71",
        x: item.fltDate,
        y: item.weight,
      }));

      const t1Data = dataArray.filter((item) => item.id === "T1");
      const t2Data = dataArray.filter((item) => item.id === "T2");

      const groupT1 = t1Data.reduce((result, item) => {
        const exItem = result.find((groupItem) => groupItem.x === item.x);

        if (exItem) {
          // 이미 있는 경우 누적
          exItem.y += item.y;
        } else {
          // 없는 경우 새로운 그룹 추가
          result.push({ ...item });
        }
        return result;
      }, []);

      const groupT2 = t2Data.reduce((result, item) => {
        const exItem = result.find((groupItem) => groupItem.x === item.x);

        if (exItem) {
          // 이미 있는 경우 누적
          exItem.y += item.y;
        } else {
          // 없는 경우 새로운 그룹 추가
          result.push({ ...item });
        }
        return result;
      }, []);

      const totalT1 = groupT1.map((item) => ({
        x: item.x,
        y: item.y,
      }));

      const totalT2 = groupT2.map((item) => ({
        x: item.x,
        y: item.y,
      }));

      last = [
        {
          id: "T1",
          color: "#ffcc33",
          fill: "#ffcc33",
        },
        {
          id: "T2",
          color: "#ff6600",
          fill: "#ff6600",
        },
      ];
      last[0].data = totalT1;
      last[1].data = totalT2;
      setConvertData(last);
    } else {
    }
  }, []);
  return (
    <ResponsiveLine
      data={convertData}
      margin={{ top: 15, right: 60, bottom: 60, left: 60 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "0",
        max: "auto",
        stacked: false,
        reverse: false,
      }}
      yFormat=" >-.2f"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: 36,
        legendPosition: "middle",
      }}
      enableGridX={false}
      pointSize={5}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ theme: "grid.line.stroke" }}
      areaOpacity={0.7}
      colors={["#ffcc33", "#ff6600"]}
      pointLabelYOffset={-12}
      enableArea={true}
      useMesh={true}
      tooltip={({ point }) => (
        <div
          style={{
            background: "#fff",
            padding: "5px",
            border: "1px solid #ccc",
          }}
        >
          DATE : {point.data.xFormatted} <br />
          {point.serieId}WT : {point.data.yFormatted}
        </div>
      )}
      legends={[
        {
          anchor: "right",
          direction: "column",
          justify: false,
          translateX: 94,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
}
